/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryClient } from "@tanstack/react-query";
import { isString, last, values } from "lodash";
export const QUERY_CLIENT = new QueryClient({
    defaultOptions: { queries: { staleTime: 5000 } },
});
export const IS_LOGGED_IN = window.IS_LOGGED_IN;
export const getBasePath = (path) => {
    let result = path.substring(1);
    const i = result.indexOf("/");
    if (i >= 0)
        result = result.substring(0, i);
    return result;
};
export const arrayOf = (t) => {
    const arr = values(t);
    return isString(last(arr)) ? arr : arr.slice(arr.length / 2, arr.length);
};
// path name
export const About = "about";
export const Privacy = "privacy";
export const TermsOfService = "tos";
export const Contact = "contact";
export const Home = "";
export const Investment = "investment";
export const Inquire = "inquire";
export const InquiryDash = "dash";
export const ManagerGallery = "gal";
export const WhiteLogo = "/dist/static/KJPLogoWhite.svg";
export const BlackLogo = "/dist/static/KJPLogoBlack.svg";
export const KNOWN_ROUTES = new Set([Privacy, TermsOfService, Contact]);
export const TOOLBAR_HEIGHT = "68px";
export const INPUT_BACKGROUND_COLOR = "rgba(0, 0, 0, 0.06)";
export const DEFAULT_PRIMARY_COLOR = "#af6a25";
export const DEFAULT_SECONDARY_COLOR = "#090802";
export const NAV_LINKS = [
    {
        label: "Home",
        to: Home,
    },
    {
        label: "About Kylie",
        to: About,
    },
    // {
    //   label: "Investment",
    //   to: Investment,
    // },
    {
        label: "Inquire",
        to: Inquire,
    },
];
